var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-spinner"}),_c('p',{staticClass:"loading-text"},[_vm._v("正在准备跳转到微信小程序...")])]):_c('div',{staticClass:"content-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }